import axios from 'axios';

export const BACKEND_URL = 'https://silabor-strapi.dingegno.com';
const API_URL = BACKEND_URL + '/api';

export const getHomePage = async () => {
    try {
        const response = await axios.get(`${API_URL}/home-page?populate=*`);
        return response.data;
    } catch (error) {
        console.error('Error fetching homepage content:', error);
        throw error;
    }
};

export const getPartners = async () => {
    try {
        const response = await axios.get(`${API_URL}/partners?populate=*`);
        return response.data;
    } catch (error) {
        console.error('Error fetching partners:', error);
        throw error;
    }
};
